import { EventEmitter2 } from 'eventemitter2';

/**
 * Event emitter bus
 */
export const events = new EventEmitter2({ wildcard: true });
